import React from 'react';
import Layout from '../components/layout/Layout';
import HeroSlider from '../components/home/HeroSlider';
import NewProducts from '../components/home/NewProducts';
import FeaturedProducts from '../components/home/FeaturedProducts';
import { useCart } from '../contexts/CartContext';
import { useScrollRestoration } from '../hooks/useScrollRestoration';

const HomePage: React.FC = () => {
  const { cart } = useCart();

  // Back from a product lands on the row it was clicked from.
  useScrollRestoration();

  return (
    <Layout cartItemsCount={cart.items.length} cartTotal={cart.total}>
      {/* The page's topic for search engines and screen readers; the hero carries it visually. */}
      <h1 className="sr-only">PCCenter – компютърни компоненти, конфигурации и сервиз</h1>
      <HeroSlider />
      <NewProducts />
      <FeaturedProducts />
    </Layout>
  );
};

export default HomePage;